import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import classnames from 'classnames'
import Helmet from 'react-helmet'
import { subscriptionReselector as stateSelector } from 'reduxModules/auth/selectors'
import Sidebar from '../generic/Sidebar'
import items from './sidebarItems'
import './styles.css'

export function CustomerCare({ subscription = null, location = { pathname: '' }, isMobile, dimensions = { height: 0 } }) {
  return (
    <div
      id="CustomerCare"
      className={classnames({
        'sidenav-wrapper': !isMobile,
        'topnav-wrapper': isMobile,
        wrapper: !isMobile
      })}
    >
      <Helmet>
        <title>Customer Care | Stan Winston School of Character Arts</title>
      </Helmet>
      <div className={classnames({ sidenav: !isMobile, topnav: isMobile, wrapper: !isMobile })}>
        <Sidebar
          items={items}
          active={location.pathname}
          subscription={subscription}
          name="customer care"
          isMobile={isMobile}
          height={dimensions.height}
        />
      </div>
      <div className="customer-care-content wrapper">
        <Outlet />
      </div>
    </div>
  )
}

CustomerCare.propTypes = {
  subscription: PropTypes.shape({
    free: PropTypes.bool,
    rank: PropTypes.number,
    plan: PropTypes.string
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  isMobile: PropTypes.bool.isRequired,
  dimensions: PropTypes.shape({
    height: PropTypes.number
  })
}

export default connect(stateSelector)(CustomerCare)
